import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import { toODataString } from '@progress/kendo-data-query';
import {
  CLEAR,
  UPDATESPLITTED,
  FORSUBMIT,
  item,
  split,
  splitAndSend,
  undo,
  remove,
  updateResponse,
  BULK_ASSIGN,
  BULK_APPOINT,
  BULK_ASSIGN_FORSUBMIT,
  UPDATERESPONSESHAREDCOST,
  UPDATERESPONSE_IS_EARLY_CONFIRMATION_REQUIRED,
  GETANNEXFILTEREDIDS,
  UPDATE_ASSIGNMENT_DELIVERY,
  UPDATE_ASSIGNMENT_DELIVERY_FINILIZED,
  ROLLBACK_DELIVERY,
  CAN_BULK_ASSIGN,
  SPLITTED_RESEND,
  RESPONSE_SUGGESTION,
  APPOINTMENT,
  REMOVE_APPOINTMENT
} from '@hobs/constants/assignmentServiceRequest';
import { actionCreator } from './utils/utils';

export function getAssignmentServiceRequest(serviceRequestId) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(`AssignmentServiceRequest/${serviceRequestId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: JSON.parse(response.response)
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: item.REQUEST };
  }
  function success(data) {
    return { type: item.SUCCESS, item: data };
  }
  function failure(error) {
    return { type: item.FAILURE, error };
  }
}

export function clearAssignmentServiceRequest() {
  return dispatch => {
    dispatch({ type: CLEAR.SUCCESS });
  };
}

export function updateAssignmentResponse(data) {
  return dispatch => {
    dispatch(request());

    return fetchSecure('AssignmentServiceRequest/Response', {
      body: data,
      method: 'PUT'
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: response.payload
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
        return { success: false, error: error.toString() };
      });
  };

  function request() {
    return { type: updateResponse.REQUEST };
  }
  function success(data) {
    return { type: updateResponse.SUCCESS, item: data };
  }
  function failure(error) {
    return { type: updateResponse.FAILURE, error };
  }
}

export const updateResponseCostShared = serviceRequestId =>
  actionCreator(
    `AssignmentServiceRequest/Response/IsSharedCost/${serviceRequestId}`,
    UPDATERESPONSESHAREDCOST,
    {
      method: 'PUT'
    }
  );

export const updateResponseEarlyConfirmationRequired = serviceRequestId =>
  actionCreator(
    `AssignmentServiceRequest/Response/IsEarlyConfirmationRequired/${serviceRequestId}`,
    UPDATERESPONSE_IS_EARLY_CONFIRMATION_REQUIRED,
    {
      method: 'PUT'
    }
  );

export const updateAssignmentDelivery = data =>
  actionCreator(
    'AssignmentServiceRequest/Delivery',
    UPDATE_ASSIGNMENT_DELIVERY,
    {
      body: data,
      method: 'PUT'
    }
  );

export const checkResponseSuggestion = data =>
  actionCreator(
    'AssignmentServiceRequest/ResponseSuggestion',
    RESPONSE_SUGGESTION,
    {
      body: data,
      method: 'POST'
    }
  );

export const appoint = (serviceRequestId, data) =>
  actionCreator(
    `AssignmentServiceRequest/${serviceRequestId}/Appointment`,
    APPOINTMENT,
    {
      body: data,
      method: 'PUT'
    }
  );

export const removeAppointment = serviceRequestId =>
  actionCreator(
    `AssignmentServiceRequest/${serviceRequestId}/Appointment`,
    REMOVE_APPOINTMENT,
    {
      method: 'DELETE'
    }
  );

export const rollbackDelivery = (serviceRequestId, deliveryLineId) => {
  const url =
    deliveryLineId !== undefined
      ? `AssignmentServiceRequest/Delivery/Rollback/${serviceRequestId}/${deliveryLineId}`
      : `AssignmentServiceRequest/Delivery/Rollback/${serviceRequestId}`;
  return actionCreator(url, ROLLBACK_DELIVERY, {
    method: 'PUT'
  });
};

export const updateAssignmentDeliveryFinalizedStatus = serviceRequestId =>
  actionCreator(
    `AssignmentServiceRequest/Delivery/FinalizeDelivery/${serviceRequestId}`,
    UPDATE_ASSIGNMENT_DELIVERY_FINILIZED,
    {
      method: 'PUT'
    }
  );

export function updateSplitted(data) {
  return dispatch => {
    dispatch(request());

    return fetchSecure('AssignmentServiceRequest/Splitted', {
      body: data,
      method: 'PUT'
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: response.payload
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: UPDATESPLITTED.REQUEST };
  }
  function success(data) {
    return { type: UPDATESPLITTED.SUCCESS, item: data };
  }
  function failure(error) {
    return { type: UPDATESPLITTED.FAILURE, error };
  }
}

export function splitAssignment(data) {
  return dispatch => {
    dispatch(request());

    return fetchSecure('AssignmentServiceRequest/Splitted', {
      body: data,
      method: 'POST'
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: response.payload
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: split.REQUEST };
  }
  function success() {
    return { type: split.SUCCESS };
  }
  function failure(error) {
    return { type: split.FAILURE, error };
  }
}

export function splitAndSendAssignment(data) {
  return dispatch => {
    dispatch(request());

    return fetchSecure('AssignmentServiceRequest/SplitAndSend', {
      body: data,
      method: 'POST'
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: response.payload
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: splitAndSend.REQUEST };
  }
  function success() {
    return { type: splitAndSend.SUCCESS };
  }
  function failure(error) {
    return { type: splitAndSend.FAILURE, error };
  }
}

export function splittedUndo(serviceRequestId) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(
      `AssignmentServiceRequest/Splitted/undo/${serviceRequestId}`,
      {
        method: 'POST'
      }
    )
      .then(response => {
        if (response.status === 200) {
          dispatch(success());

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, payload: response.payload };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: undo.REQUEST };
  }
  function success() {
    return { type: undo.SUCCESS };
  }
  function failure(error) {
    return { type: undo.FAILURE, error };
  }
}

export function splittedRemove(serviceRequestId) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(
      `AssignmentServiceRequest/Splitted/Delete/${serviceRequestId}`,
      { method: 'DELETE' }
    )
      .then(response => {
        if (response.status === 200) {
          dispatch(success());

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: JSON.parse(response.response)
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: remove.REQUEST };
  }
  function success() {
    return { type: remove.SUCCESS };
  }
  function failure(error) {
    return { type: remove.FAILURE, error };
  }
}

export const splittedResend = serviceRequestId =>
  actionCreator(
    `AssignmentServiceRequest/Resend/${serviceRequestId}`,
    SPLITTED_RESEND,
    {
      method: 'POST'
    }
  );

export function forSubmit(serviceRequestId) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(
      `AssignmentServiceRequest/Splitted/ForSubmit/${serviceRequestId}`
    )
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: JSON.parse(response.response)
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: FORSUBMIT.REQUEST };
  }
  function success(payload) {
    return { type: FORSUBMIT.SUCCESS, forSubmit: payload };
  }
  function failure(error) {
    return { type: FORSUBMIT.FAILURE, error };
  }
}

export function bulkAssignForSubmit() {
  return dispatch => {
    dispatch(request());
    return fetchSecure('AssignmentServiceRequest/BulkAssignment/ForSubmit')
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };
  function request() {
    return { type: BULK_ASSIGN_FORSUBMIT.REQUEST };
  }
  function success(payload) {
    return { type: BULK_ASSIGN_FORSUBMIT.SUCCESS, bulkForSubmit: payload };
  }
  function failure(error) {
    return { type: BULK_ASSIGN_FORSUBMIT.FAILURE, error };
  }
}
export function bulkAssign(data) {
  return dispatch => {
    dispatch(request());
    return fetchSecure('AssignmentServiceRequest/BulkAssignment', {
      body: data,
      method: 'POST'
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };
  function request() {
    return { type: BULK_ASSIGN.REQUEST };
  }
  function success() {
    return { type: BULK_ASSIGN.SUCCESS };
  }
  function failure(error) {
    return { type: BULK_ASSIGN.FAILURE, error };
  }
}

export function bulkAppoint(data) {
  return dispatch => {
    dispatch(request());
    return fetchSecure('AssignmentServiceRequest/BulkAppointment', {
      body: data,
      method: 'POST'
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };
  function request() {
    return { type: BULK_APPOINT.REQUEST };
  }
  function success() {
    return { type: BULK_APPOINT.SUCCESS };
  }
  function failure(error) {
    return { type: BULK_APPOINT.FAILURE, error };
  }
}

export const canBulkAssign = body =>
  actionCreator('AssignmentServiceRequest/CanBulkAssign', CAN_BULK_ASSIGN, {
    body,
    method: 'POST'
  });

export function getAnnexFilteredServiceRequestIds(path, params = {}) {
  return dispatch => {
    dispatch(request());

    const oDataParams = toODataString(params);
    const regExp = /('%3Cguid%3E)|(%3C%2Fguid%3E')/g;

    return fetchSecure(`${path}?$count=true&${oDataParams.replace(regExp, '')}`)
      .then(response => {
        const result = {
          data: response.payload.value,
          total: response.payload['@odata.count']
        };
        dispatch(success(result));
        return { success: true, ...result };
      })
      .catch(error => {
        dispatch(failure(error.toString()));
        return { success: false };
      });
  };

  function request() {
    return { type: GETANNEXFILTEREDIDS.REQUEST };
  }
  function success(payload) {
    return { type: GETANNEXFILTEREDIDS.SUCCESS, payload };
  }
  function failure(error) {
    return { type: GETANNEXFILTEREDIDS.FAILURE, error };
  }
}
